module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av477-f2cbf07bb78d7dae5c1f8102e1eae6bc.jpg";